import { SearchOutlined } from '@ant-design/icons'
import React from 'react'

import { PROPERTY_TYPES } from '../../common/drmTypes'
import { useColumnCustomSearchFilter } from './useColumnCustomSearchFilter'
import { useDateRangeFilter } from './useColumnDateRangeFilter'
import { useNumberRangeFilter } from './useColumnNumberRangeFilter'
import { useColumnOptionFilter } from './useColumnOptionFilter'
import { useColumnSearchFilter } from './useColumnSearchFilter'
import { useDualColumnSearchFilter } from './useDualColumnSearchFilte'
import { useLabelFilter } from './useLabelFilter'
import { useMoneyRangeFilter } from './useMoneyRangeFilter'
import { useNestedColumnSearchFilter } from './useNestedColumnSearchFilter'

const types = [
  PROPERTY_TYPES.AREA,
  PROPERTY_TYPES.BUILDING,
  PROPERTY_TYPES.UNIT,
]

export const createFilterIcon = (filtered: boolean) => (
  <SearchOutlined className={filtered ? 'text-primary' : 'text-gray-600'} />
)

export const columnFilterIcon = {
  filterIcon: (filtered: boolean) => (
    <SearchOutlined className={filtered ? 'text-primary' : 'text-gray-600'} />
  ),
}

/**
 * client-side Ant Table columns filter by propertyType.
 */
export function usePropertyTypeFilter<T>() {
  const getPropertyTypeFilter =
    useColumnOptionFilter<T>(types).getColumnOptionFilter
  return { getPropertyTypeFilter }
}

export function useColumnFilters<T>() {
  const { getSearchFilter: searchFilter } = useColumnSearchFilter<T>()
  const { getDateRangeFilter: dateFilter } = useDateRangeFilter<T>()
  const { getNumberRangeFilter: rangeFilter } = useNumberRangeFilter<T>()
  const { getMoneyRangeFilter: moneyFilter } = useMoneyRangeFilter<T>()
  const { getCustomSearchFilter: customSearchFilter } =
    useColumnCustomSearchFilter<T>()
  const { getDualSearchFilter: dualSearchFilter } =
    useDualColumnSearchFilter<T>()
  const { getPropertyTypeFilter: propertyTypeFilter } =
    usePropertyTypeFilter<T>()
  const { getNestedSearchFilter: nestedSearchFilter } =
    useNestedColumnSearchFilter<T>()
  const { getLabelFilter: labelFilter } = useLabelFilter<T>()

  return {
    dateFilter,
    rangeFilter,
    moneyFilter,
    searchFilter,
    dualSearchFilter,
    customSearchFilter,
    propertyTypeFilter,
    nestedSearchFilter,
    labelFilter,
  }
}
